import { faPhoneAlt } from "@fortawesome/pro-solid-svg-icons/faPhoneAlt";
import { faWebcam } from "@fortawesome/pro-solid-svg-icons/faWebcam";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { Link } from "react-router-dom";
import CallLink from "./CallLink";
import * as HostState from "../Types/HostStateTypes";
import Price from "./Price";
function Callbox(host) {
  var status = host.status;
  switch (status) {
    case HostState.CONNECTED:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faPhoneAlt
      }), "\u202F Ich telefoniere gerade", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, "Bin gleich wieder verf\u00FCgbar")));
    case HostState.VIDEOCHAT:
      return /*#__PURE__*/React.createElement(Link, {
        to: "/profil/".concat(host.name, "/")
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faWebcam
      }), "\u202F Jetzt im Chat", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("small", null, "Besuche meine Live Cam"));
    case HostState.OFFLINE0900:
    case HostState.OFFLINE:
      return /*#__PURE__*/React.createElement(Link, {
        to: "/profil/".concat(host.name, "/")
      }, "Gerade kein", /*#__PURE__*/React.createElement("br", null), " Telefon", /*#__PURE__*/React.createElement("br", null));
    case HostState.INCOMING:
      return /*#__PURE__*/React.createElement("div", null, "Werde verbunden...");
    case HostState.FREE:
    default:
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CallLink, {
        host: host
      }), /*#__PURE__*/React.createElement(Price, {
        short: true
      }));
  }
}
export default Callbox;